<template>
  <header>
    <transition name="slide-up">
      <Notification />
    </transition>
    <div class="container">
      <div class="flex__between">
        <router-link to="/" class="link__none home-link">
          <img
            src="https://cdn.fbhl.dev/servicing/images/fbhl-home-svg.svg"
            alt="FBHL Logo"
            width="100px"
            height="100px"
          />
        </router-link>
        <a
          href="https://loansphereservicingdigital.bkiconnect.com/fbhl"
          rel="noreferrer external nofollow"
          name="Servicing digital webpage"
          class="btn btn__sm btn__orange"
        >Login/Make a Payment</a>
        <Mobile />
      </div>
      <Standard />
    </div>
    <div id="banner" class="banner container">
      <p class="banner-message">If you received a Notice of Servicing Transfer letter <a href="/service-transfer">click here for additional information.</a></p>
      <button class="banner-close" @click="dismissBanner">×</button>
    </div>
  </header>
</template>

<script>
import Notification from "./Notification";
import Mobile from "./Nav/Mobile";
import Standard from "./Nav/Standard";

export default {
  components: {
    Notification,
    Mobile,
    Standard,
  },
  methods: {
    dismissBanner() {
      const banner = document.getElementById("banner");
      if (banner) {
        banner.style.display = "none";
      }
    },
  },
};
</script>

<style scoped lang="scss">
header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
}
.flex__between .btn {
  display: none;
}
@media (min-width: $lg) {
  .flex__between .btn {
    display: block;
  }
}

.banner {
    background-color: #ea5b24;
    color: #333;
    padding: 10px 20px;
    display: none;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    position: relative;
    z-index: 1000;

}
.banner a {
    color: #fff;
    text-decoration: underline;
}

.banner-message {
    margin: 0;
}

.banner-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #333;
}
</style>
